'use strict';
const angular = require('angular');

export class ProjectItemEditComponent {
  /*@ngInject*/
  constructor(ProjectItemService, $uibModal, User, dialogs, SettingsService) {
    this.ProjectItemService = ProjectItemService;
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.User = User;

    this.projectItem = {
      highlight: false
    };
    this.users = [];

    //this.dueDatePopupOpened = false;

    this.User.query(data => {
      this.users = data.map(user => {
        return {
          value: user._id,
          name: user.shortName || (user.firstName + ' ' + user.lastName)
        };
      });
    });
  }

  /*
  openDueDatePopup() {
    this.dueDatePopupOpened = true;
  }
  */

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = (projectItem) => {
        var infotxt = (that.config.data) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The project item has been "+ infotxt +" successfully");
        dlg.result.then(() => {
          that.close({$value: projectItem});
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (!this.trackTime) { // todo: check why this wont work; really don't get it right now
        delete this.projectItem.progressActual;
        delete this.projectItem.progressTarget;
      }

      if (this.config.data) {  // edit
        this.ProjectItemService.update({id: this.projectItem._id}, this.projectItem, onSuccess, onError)
      } else { // new
        this.ProjectItemService.save(this.projectItem, onSuccess, onError);
      }
    }
  }

  userLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'userLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (user) {
        that.projectItem.assignedTo = user._id;
      },
      function () { /* cancel */ }
    );

  }

  $onInit = () => {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("data")) {
      this.projectItem = angular.copy(this.config.data);

      if (this.projectItem.assignedTo)
        this.projectItem.assignedTo = this.projectItem.assignedTo._id;

      if (this.projectItem.progressActual || this.projectItem.progressTarget)
        this.trackTime = true;

      //this.task = angular.copy(this.config.data);
      //this.task.dueDate = new Date(this.task.dueDate);
      //this.customFields = this.task.customFields || {};
    }
  };

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.projectItemEdit', [])
  .component('projectItemEdit', {
    template: require('./project-item-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ProjectItemEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/project-item-edit/project-item-edit.component.js